import { motion } from "framer-motion";
import { ArrowRight, MapPin } from "lucide-react";
import { MEDIA, SITES } from "../data/content";

const fade = { hidden: { opacity: 0, y: 28 }, show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.8, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] } }) };

export const Hero = ({ t }) => {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="top" data-testid="hero-section" className="relative min-h-[100svh] flex items-end overflow-hidden">
      <div className="absolute inset-0">
        <img src={MEDIA.hero} alt="Aleea cu copaci din Grădina Copou, Iași" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/45 to-black/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/30" />
      </div>

      <div className="relative max-w-7xl mx-auto w-full px-6 md:px-12 pb-20 md:pb-28 pt-32">
        <motion.div initial="hidden" animate="show" className="max-w-3xl">
          <motion.div custom={0} variants={fade} className="flex items-center gap-2 mb-6">
            <MapPin size={15} className="text-copou-primary" />
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-white/85">{t.hero.overline}</span>
          </motion.div>

          <motion.h1 custom={1} variants={fade} className="font-serif font-light text-white text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight">
            {t.hero.title}
          </motion.h1>

          <motion.p custom={2} variants={fade} className="mt-7 text-base sm:text-lg text-white/85 leading-relaxed max-w-2xl">
            {t.hero.subtitle}
          </motion.p>

          <motion.div custom={3} variants={fade} className="mt-10 flex flex-col sm:flex-row gap-4">
            <button
              data-testid="hero-cta-listings"
              onClick={() => scrollTo("listings")}
              className="group inline-flex items-center justify-center gap-2 border border-copou-primary bg-copou-primary text-white px-8 py-4 text-sm font-semibold uppercase tracking-wider hover:bg-copou-primaryHover transition-colors"
            >
              {t.hero.cta1}
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </button>
            <a
              href={SITES.copouGuide}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-cta-guide"
              className="inline-flex items-center justify-center gap-2 border border-white/60 text-white px-8 py-4 text-sm font-semibold uppercase tracking-wider hover:bg-white hover:text-copou-ink transition-colors"
            >
              {t.hero.cta2}
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
